var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgX = function (props) { return (_jsxs("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" }, props, { children: [_jsx("path", { fill: "currentColor", d: "M11.816 11.082 9.666 8.25h-.892v.053l2.57 3.41.735.944 2.255 3.042h.892v-.052l-2.675-3.567-.735-.945z" }), _jsx("path", { fill: "currentColor", d: "M12 4c-4.444 0-8 3.556-8 8s3.556 8 8 8 8-3.556 8-8-3.556-8-8-8m1.882 12.549-2.457-3.242-2.72 3.242H7.19l3.555-4.183L6.98 7.399h3.138l2.3 3.032L14.98 7.4h1.517l-3.347 3.974 3.922 5.176h-3.19" })] }))); };
export default SvgX;
